<script>
  import { onMount } from 'svelte'
  import posthog from 'posthog-js'
  import { Cookie } from 'lucide-svelte'
  import Button from '@components/buttons/button.svelte'
  import { CONSENT_KEY, getCookieConsent } from '@lib/utils/cookie-consent'
  import { appState } from '@state/app-state.svelte.js'

  let { showTrigger = false } = $props()

  onMount(() => {
    const stored = getCookieConsent()
    appState.cookieConsent = stored === 'accepted' ? true : stored === 'declined' ? false : null
    if (appState.cookieConsent) posthog.opt_in_capturing()
  })

  function reopen() {
    localStorage.removeItem(CONSENT_KEY)
    appState.cookieConsent = null
  }

  function accept() {
    posthog.opt_in_capturing()
    localStorage.setItem(CONSENT_KEY, 'accepted')
    appState.cookieConsent = true
    window.altruistCaptureCurrentPageview?.({ force: true })
  }

  function decline() {
    posthog.opt_out_capturing()
    localStorage.setItem(CONSENT_KEY, 'declined')
    appState.cookieConsent = false
  }
</script>

{#if showTrigger}
  <Button variant="naked" text="Cookie preferences" onclick={reopen} class="text-gray-400 hover:text-gray-600 text-xs" />
{/if}

{#if appState.cookieConsent === null}
  <div class="fixed bottom-0 inset-x-0 z-50 flex justify-center p-4 pointer-events-none">
    <div class="pointer-events-auto flex items-center gap-4 bg-white border border-gray-200 shadow-lg rounded-lg px-5 py-3 text-sm text-gray-600 max-w-fit">
      <Cookie size={18} class="shrink-0 text-gray-400" />
      <p>We use analytics cookies to understand visits and improve your experience.</p>
      <div class="flex items-center gap-2 shrink-0">
        <Button variant="primary" text="Accept" onclick={accept} size="sm" />
        <Button variant="naked" text="Decline" onclick={decline} class="text-gray-400 hover:text-gray-600 text-xs" />
      </div>
    </div>
  </div>
{/if}
